import { apiClient } from '@common/api'

/**
 * sessionHeartbeat API service
 * Converted from AngularJS: api.sessionHeartbeat.js
 */
export const sessionHeartbeatApi = {
  get: () =>
    apiClient.get('/sessionheartbeat'),
}
